import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../Api/baseQueryWithReauth';
import { TagTypes } from '../../../Api/Types/tagTypes';
import {
  KsefIncomingStatusResult,
  RetryFailedKsefIncomingRequest,
  RetryFailedKsefIncomingResult,
} from '../Types/ksefIncoming.types';

export const ksefIncomingApi = createApi({
  reducerPath: 'ksefIncomingApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: [TagTypes.KsefIncomingStatus],
  endpoints: (builder) => ({
    getKsefIncomingStatus: builder.query<KsefIncomingStatusResult, { failedLimit?: number } | void>(
      {
        query: (params) => {
          const failedLimit = params?.failedLimit;

          return {
            url: '/ksef/incoming/status',
            params: failedLimit !== undefined ? { failedLimit } : undefined,
          };
        },
        providesTags: [TagTypes.KsefIncomingStatus],
      }
    ),
    retryFailedKsefIncoming: builder.mutation<
      RetryFailedKsefIncomingResult,
      RetryFailedKsefIncomingRequest
    >({
      query: (body) => ({
        url: '/ksef/incoming/retry-failed',
        method: 'POST',
        body,
      }),
      invalidatesTags: [TagTypes.KsefIncomingStatus],
    }),
  }),
});

export const { useGetKsefIncomingStatusQuery, useRetryFailedKsefIncomingMutation } =
  ksefIncomingApi;
